import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {
	Label,
	LoadingContainer,
	NoData,
	SectionWrapper,
} from './ChartList.styles';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import { useMultipleDiversityContext } from 'contexts/SupplierDiversity/MultipleDiversityProvider';
import Header from 'SupplierDiversity/components/Header/Header';
import Filter from 'SupplierDiversity/components/Filter/Filter';

const chartTitle = 'Multiple Diversity';

const MultipleDiversity = () => {
	const {
		isLoading,
		data,
		options,
		count,
		countFilterHandler,
	} = useMultipleDiversityContext();
	return (
		<SectionWrapper>
			<Header chartTitle={chartTitle}>
				{!isLoading && (
					<Filter>
						<Label>Count:</Label>
						<div>
							<ApSimpleDropdown
								options={count.options}
								selected={count.selected}
								onChange={countFilterHandler}
							/>
						</div>
					</Filter>
				)}
			</Header>
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact highcharts={Highcharts} options={options} />
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default MultipleDiversity;
